<template>
  <div>
    <chat-window ref="chat" :showAudio="false"
                            :showAddRoom="true"
                            :showFiles="false"
                            :showEmojis="false"
                            :currentUserId="currentUserId"
                            :rooms="rooms"
                            :messagesLoaded="true"
                            :messages="roomMessages"
                            :textMessages="textMessages"
                            @sendMessage="sendMessage"
                            @addRoom="addRoom"/>

    <b-modal size="lg" ref="searchUser" hide-footer :title="$t('Start room')">
      <searchUser  @sendMessage="sendMessage" @hideAddRoom="hideAddRoom"/>
    </b-modal>
  </div>
</template>

<script>
import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'
import searchUser from './searchUser'

export default {
  components: {
    ChatWindow,
    searchUser
  },
  data () {
    return {
      WS: null,
      curRoom: null,
      allMessages: [],
      rooms: [],
      textMessages: {
        TYPE_MESSAGE: this.$t('Enter message...'),
        SEARCH: this.$t('Search')
      }
    }
  },
  methods: {
    async webSocket (thisRef) {
      let sessionId = this.$cookie.get('session_id')
      let loc = window.location
      let newUri = ''
      if (loc.protocol === 'https:') {
        newUri = 'wss:'
      } else {
        newUri = 'ws:'
      }
      newUri += '//' + loc.host
      newUri += loc.pathname + 'websoket_chat'

      this.WS = new WebSocket(newUri, sessionId)
      await this.$store.dispatch('Support/GET_ADMIN_ID')

      this.WS.onclose = function (evt) {
        if (evt.code === 1009) {
          thisRef.$root.$emit('makeToasts', 'danger', evt.reason + ' ; Tech Chat closed , reload page', 'Error')
        }
      }

      this.WS.onmessage = async (evt) => {
        let rowData = await evt.data.text()
        let jsonData = JSON.parse(rowData)
        for (let el of jsonData.messages) {
          el.full_name = 'Not found'
          if (el.is_admin_origin) {
            for (let elUser of this.sysUsers) {
              if (el.admin_id === elUser.user_id) {
                el.full_name = elUser.login
                break
              }
            }
          } else {
            for (let elUser of this.allUsers) {
              if (el.client_id === elUser.user_id) {
                el.full_name = elUser.login
                break
              }
            }
          }
          if (el.group_id !== -1) {
            el.full_name = 'Group'
            el.client_id = el.group_id
            el.admin_id = el.group_id
          }

          let tmpRoom = {
            roomId: el.client_id,
            roomName: el.full_name + ' (' + el.client_id + ')',
            unreadCount: (el.is_admin_origin ? 0 : 1),
            lastMessage: {
              content: el.msg,
              sender_id: (el.is_admin_origin ? el.admin_id : el.client_id),
              username: (el.is_admin_origin ? el.full_name + '(Admin)' : el.full_name),
              date: el.last_update,
              seen: el.is_admin_origin,
              new: !el.is_admin_origin,
              distributed: false
            },
            users: [
              {
                _id: el.client_id,
                username: (el.is_admin_origin ? el.full_name + '(Admin)' : el.full_name)
              }
            ]
          }
          if (el.admin_id !== 0) {
            tmpRoom.users.push(
              {
                _id: el.admin_id,
                username: ''
              }
            )
          }
          let isRoomAdded = false
          this.rooms.forEach(element => {
            if (element.roomId === tmpRoom.roomId) {
              isRoomAdded = true
              element.unreadCount = (el.is_admin_origin ? 0 : element.unreadCount + 1)
              element.lastMessage = {
                content: el.msg,
                sender_id: (el.is_admin_origin ? el.admin_id : el.client_id),
                username: (el.is_admin_origin ? el.full_name + '(Admin)' : el.full_name),
                date: el.last_update,
                seen: el.is_admin_origin,
                new: !el.is_admin_origin,
                distributed: false
              }
            }
          })
          if (!isRoomAdded) {
            this.rooms.push(tmpRoom)
          };
        }

        for (let el of jsonData.messages) {
          el.full_name = 'Not found'
          if (el.is_admin_origin) {
            for (let elUser of this.sysUsers) {
              if (el.admin_id === elUser.user_id) {
                el.full_name = elUser.login
                break
              }
            }
          } else {
            for (let elUser of this.allUsers) {
              if (el.client_id === elUser.user_id) {
                el.full_name = elUser.login
                break
              }
            }
          }
          if (el.group_id !== -1) {
            el.full_name = 'Group'
            el.admin_id = el.group_id
            el.client_id = el.group_id
          }

          el._id = el.id
          el.content = (el.is_admin_origin ? el.full_name + '(' + el.admin_id + ')\n' + el.msg : el.msg)
          el.roomId = el.client_id
          el.sender_id = (el.is_admin_origin ? el.admin_id : el.client_id)
          el.username = (el.is_admin_origin ? el.full_name + '(Admin)' : el.full_name)
          el.timestamp = this.$root.getMomentWithTZDelta(el.last_update).format('HH:mm:ss(DD.MM.YY)')
          el.system = false
          el.disable_actions = true
          el.disable_reactions = true
        }
        this.allMessages.push(...jsonData.messages)
      }
    },
    addRoom () {
      this.$refs.searchUser.show()
    },
    sendMessage (msgData) {
      if (msgData.content.length > 4096) {
        this.$root.$emit('makeToasts', 'danger', 'Max message size 4096 , your message size = ' + msgData.content.length, 'Error')
        return
      }
      let scoupedGroupID = -1
      if (msgData.hasOwnProperty('group_id')) {
        scoupedGroupID = msgData.group_id
      }
      let msg = {
        message: msgData.content,
        client_id: msgData.roomId,
        group_id: scoupedGroupID
      }
      for (let el of this.rooms) {
        if (el.roomId === msgData.roomId) {
          el.unreadCount = 0
        }
      }
      this.WS.send(JSON.stringify(msg))
    },
    hideAddRoom () {
      this.$refs.searchUser.hide()
    }
  },
  mounted () {
    this.webSocket(this)
    this.$store.dispatch('Users/GET_ALL_USERS')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.$watch(
      '$refs.chat.room',
      (value) => {
        this.curRoom = value
      }
    )
  },
  beforeDestroy () {
    this.WS.close()
  },
  watch: {
    allUsers: function (users) {
      for (let el of this.allMessages) {
        el.full_name = 'Not found'
        if (el.is_admin_origin) {
          for (let elUser of this.sysUsers) {
            if (el.admin_id === elUser.user_id) {
              el.full_name = elUser.login
              break
            }
          }
        } else {
          for (let elUser of users) {
            if (el.client_id === elUser.user_id) {
              el.full_name = elUser.login
              break
            }
          }
        }
      }
      this.allMessages = JSON.parse(JSON.stringify(this.allMessages))
    }
  },
  computed: {
    roomMessages () {
      let tmp = []
      if (this.curRoom) {
        for (let el of this.allMessages) {
          if (el.client_id === this.curRoom.roomId) {
            tmp.push(el)
          }
        }
      }
      return tmp
    },
    currentUserId () {
      return this.$store.getters['Support/ADMIN_ID'].user_id
    },
    allUsers () {
      return this.$store.getters['Users/ALL_USERS']
    },
    sysUsers () {
      return this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/support/support.vue